var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',_vm._l((_vm.roles),function(role){return _c('ModListUserBodyRoleComp',{key:role.id,attrs:{"role":role}})}),1)}
var staticRenderFns = []

export { render, staticRenderFns }